import React from "react";
import PropTypes from "prop-types";

class ToggleButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSelection: this.props.initialSelection
    };

    this._toggleButton = this._toggleButton.bind(this);
  }

  _toggleButton(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }
    const index = $(e.currentTarget).data("index");
    this.props.buttons[index].callback(e);
    this.setState({ currentSelection: index });
  }

  renderButtons() {
    const { buttons, colorOverride } = this.props;
    const currentSelection = this.state.currentSelection;

    return buttons.map((button, i) => {
      const style = {};
      if (currentSelection === i) {
        style.backgroundColor = this.props.colorOverride;
      }
      const slectionClass = currentSelection === i ? "" : " no-select";
      return (
        <div
          key={"toggle-button-" + i}
          style={{ width: 100 / buttons.length + "%" }}
        >
          <button
            className={`submit selected ${slectionClass}`}
            data-index={i}
            style={style}
            aria-pressed={currentSelection === i}
            onClick={this._toggleButton}
          >
            {button.label}
          </button>
        </div>
      );
    });
  }

  render() {
    const disabledClass = this.props.disabled ? " disabled" : "";
    const noBorderClass = this.props.noborder ? " noborder" : "";

    return (
      <div
        className={`${
          this.props.className
        } toggle-set ${disabledClass} ${noBorderClass}`}
      >
        {this.renderButtons()}
      </div>
    );
  }
}

ToggleButton.propTypes = {
  initialSelection: PropTypes.number,
  className: PropTypes.string,
  colorOverride: PropTypes.string,
  disabled: PropTypes.bool,
  noborder: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      callback: PropTypes.func
    })
  )
};

ToggleButton.defaultProps = {
  initialSelection: 0,
  className: "",
  colorOverride: "",
  noborder: false,
  disabled: false,
  buttons: []
};

export { ToggleButton };
